module.exports = __webpack_public_path__ + "img/img-01.695e4885.svg";